var _g, _g2, _g3, _g4, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e4QatXBRDS91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e4QatXBRDS92"
  }, /*#__PURE__*/React.createElement("line", {
    id: "e4QatXBRDS93",
    x1: -5,
    y1: 0,
    x2: -5,
    y2: 0,
    transform: "translate(16.3333 74)",
    opacity: 0,
    paintOrder: "stroke fill markers",
    fill: "none",
    stroke: "#52509a",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "e4QatXBRDS94",
    x1: -5.000412,
    y1: 0,
    x2: -5.000412,
    y2: 0,
    transform: "translate(26.332888 74)",
    opacity: 0,
    fill: "none",
    stroke: "#52509a",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "e4QatXBRDS95",
    x1: -4.33335,
    y1: 0,
    x2: -4.33335,
    y2: 0,
    transform: "translate(45.66665 74)",
    opacity: 0,
    fill: "none",
    stroke: "#52509a",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "e4QatXBRDS96"
  }, /*#__PURE__*/React.createElement("line", {
    id: "e4QatXBRDS97",
    x1: -5,
    y1: 0,
    x2: -5,
    y2: 0,
    transform: "translate(16.3333 74)",
    opacity: 0,
    fill: "none",
    stroke: "#52509a",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "e4QatXBRDS98",
    x1: -5,
    y1: 0,
    x2: -5,
    y2: 0,
    transform: "translate(36.3333 74)",
    opacity: 0,
    fill: "none",
    stroke: "#52509a",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "e4QatXBRDS99",
    x1: -4.33335,
    y1: 0,
    x2: -4.33335,
    y2: 0,
    transform: "translate(45.66665 74)",
    opacity: 0,
    fill: "none",
    stroke: "#52509a",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "e4QatXBRDS910"
  }, /*#__PURE__*/React.createElement("line", {
    id: "e4QatXBRDS911",
    x1: -10,
    y1: 0,
    x2: -10,
    y2: 0,
    transform: "translate(21.3333 74)",
    opacity: 0,
    fill: "none",
    stroke: "#52509a",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "e4QatXBRDS912",
    x1: -5,
    y1: 0,
    x2: -5,
    y2: 0,
    transform: "translate(46.3333 74)",
    opacity: 0,
    fill: "none",
    stroke: "#52509a",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "e4QatXBRDS913"
  }, /*#__PURE__*/React.createElement("line", {
    id: "e4QatXBRDS914",
    x1: -5,
    y1: 0,
    x2: -5,
    y2: 0,
    transform: "translate(16.3333 74)",
    fill: "none",
    stroke: "#52509a",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "e4QatXBRDS915",
    x1: -9.33335,
    y1: 0,
    x2: -9.33335,
    y2: 0,
    transform: "translate(40.66665 74)",
    opacity: 0,
    fill: "none",
    stroke: "#52509a",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "e4QatXBRDS916",
    d: "M51.6702,63.3333c-.223,1.7523-.3369,3.5333-.3369,5.3333v5.3334l.3369-10.6667Zm0,0c2.42-19.017,17.6882-34.6667,39.6631-34.6667L88.6666,39.3333h-8l2.6667,5.3333L78,50h-10.6667l5.3333,5.3333L70,60.6666h-10.6667l-7.6631,2.6667Z",
    transform: "translate(-40 0)",
    fill: "none",
    stroke: "#52509a",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuill);
export default __webpack_public_path__ + "static/media/quill.0b51f56b2a6f9494367bb0ae49095598.svg";
export { ForwardRef as ReactComponent };